import TransfersPage from '../pages/admin/reports/transfers/transfers-page'
export default TransfersPage
